<cap-list-loader [listLoader]="listLoader" [showTotal]="true">
  <div class="cap-list-loader-content">
    <table [attr.aria-label]="'BerechtigtePersonen' | translate" class="cap-table-detail">
      <thead>
        <ng-template [ngTemplateOutlet]="tableHeaders"></ng-template>
      </thead>
      <tbody>
        <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
      </tbody>
    </table>
  </div>
</cap-list-loader>

<ng-template #tableHeaders>
  <tr>
    <th>{{"Personalien" | translate}}</th>
    <th>{{"Eigentumsform" | translate}}</th>
    @if (!mitHist) {
      <th>{{"AnteilEigentum" | translate}}</th>
    }
    <th>{{"Grundstueck" | translate}}</th>
    @if (!mitHist) {
      <th>{{"Totalflaeche" | translate}}</th>
    }
    @if (!mitHist) {
      <th>{{"Wertquote" | translate}}</th>
    }
  </tr>
</ng-template>

<ng-template #tableRows>
  @for (eig of listLoader?.items; track eig; let i = $index) {
    <tr>
      <td>
        @for (p of eig.model.personGbListEntry; track p; let i = $index) {
          <cap-kompakt-persongb
            [auskunftsperre]="p.auskunftsperre"
            [capHistinfo]="p.histInfo"
            [item]="p"
            [itemMasterId]="p.id"></cap-kompakt-persongb>
          @if (p && i < eig.model.personGbListEntry.length - 1) {
            <br />
          }
        }
      </td>
      <td [capHistinfo]="eig.model.histInfo">{{ eig.model.eigentumsform?.valueOf() | translate }}</td>
      @if (!mitHist) {
        <td>
          @if (!eig.model.quoteUnbekannt) {
            <span> {{ eig.model.quote?.zaehler }}/{{ eig.model.quote?.nenner }} </span>
          }
          @if (eig.model.quoteUnbekannt) {
            <span>
              {{ "eigentumanteil.unbekannt" | translate }}
            </span>
          }
        </td>
      }
      <td>
        <cap-kompakt-grundstueck
          [capHistinfo]="eig.model.grundstueckGbListEntry.histInfo"
          [item]="eig.model.grundstueckGbListEntry"
          [navigateTo]="navTargets.NAV_GRUNDSTUECK_EIGENTUM"></cap-kompakt-grundstueck>
      </td>
      @if (!mitHist) {
        <td>
          @if (eig.model.grundstueckGbListEntry?.flaecheQuadratMeter) {
            <span> {{ eig.model.grundstueckGbListEntry.flaecheQuadratMeter }}&nbsp;m² </span>
          }
        </td>
      }
      @if (!mitHist) {
        <td>
          @if (!eig.model.quoteAnStammgrundstueckUnbekannt && eig.model.quoteAnStammgrundstueck) {
            <span> {{ eig.model.quoteAnStammgrundstueck.zaehler }} /{{ eig.model.quoteAnStammgrundstueck.nenner }} </span>
          }
          @if (eig.model.quoteAnStammgrundstueckUnbekannt) {
            <span>
              {{ "eigentumanteil.unbekannt" | translate }}
            </span>
          }
        </td>
      }
    </tr>
    @for (a of eig.model.angemerkteGrundstuecke | orderByGrundstuecknummer: true : "grundstueckGbListEntry"; track a) {
      <tr>
        <td></td>
        <td>
          <span class="anmerkungsGrundstueck">{{"Anmerkungsgrundstueck" | translate}}</span>
        </td>
        @if (!mitHist) {
          <td>
            @if (!eig.model.quoteUnbekannt) {
              <span class="anmerkungsGrundstueck"> {{ eig.model.quote?.zaehler }}/{{ eig.model.quote?.nenner }} </span>
            }
            @if (eig.model.quoteUnbekannt) {
              <span class="anmerkungsGrundstueck">
                {{ "eigentumanteil.unbekannt" | translate }}
              </span>
            }
          </td>
        }
        <td>
          <span class="anmerkungsGrundstueck">
            <cap-kompakt-grundstueck
              [capHistinfo]="a.histInfo"
              [item]="a"
              [navigateTo]="navTargets.NAV_GRUNDSTUECK_EIGENTUM"></cap-kompakt-grundstueck>
          </span>
        </td>
        @if (!mitHist) {
          <td>
            @if (a.flaecheQuadratMeter) {
              <span class="anmerkungsGrundstueck"> {{ a.flaecheQuadratMeter }}&nbsp;m² </span>
            }
          </td>
        }
        @if (!mitHist) {
          <td>
            @if (!eig.model.quoteAnStammgrundstueckUnbekannt && eig.model.quoteAnStammgrundstueck) {
              <span class="anmerkungsGrundstueck">
                {{ eig.model.quoteAnStammgrundstueck.zaehler }}/{{ eig.model.quoteAnStammgrundstueck.nenner }}
              </span>
            }
            @if (eig.model.quoteAnStammgrundstueckUnbekannt) {
              <span class="anmerkungsGrundstueck">
                {{ "eigentumanteil.unbekannt" | translate }}
              </span>
            }
          </td>
        }
      </tr>
    }
  }
</ng-template>

<ng-template #loading>
  <cap-spinner-small></cap-spinner-small>
</ng-template>

<ng-template #gemGrundbuch>
  <div class="mb-2 mt-2">
    <span>{{"gemaessGrundbuch" | translate}}</span>
  </div>
</ng-template>
